import { middleSidePartOfDoubleWeb, topSidePartOfWeb } from './parts/sideParts'
import { verticalPartsOfWeb } from './parts/verticalParts'

export const crossDoubleWeb = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2?: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  await verticalPartsOfWeb(ctx, webColor2 || webColor, stitchColor, printLeatherTypeValue)
  // ウェブ先端
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  // ウェブ_横＿中間
  await middleSidePartOfDoubleWeb(ctx, webColor, stitchColor, printLeatherTypeValue)
}
